// @ts-ignore TODO: how define?
const exportData: Nullable<InternalExportData> = window.portunaIntranetExport || null;

function exportEnabled(): boolean
{
    return null !== exportData;
}

function exportSettings(): Partial<InternalExportData>
{
    return null !== exportData ? exportData : {};
}

function exportedIntranetDomain(): string
{
    return exportSettings().domain || '';
}

function exportToken(): string
{
    return exportSettings().token || '';
}

function exportDefaultRoute(): string
{
    return exportSettings().route || '';
}

export {
    exportSettings,
    exportEnabled,
    exportedIntranetDomain,
    exportToken,
    exportDefaultRoute,
};